import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ContentLayout,
  Header,
  Container,
  Box,
  SpaceBetween,
} from '@cloudscape-design/components';
import { Button } from '../common/Button';
import { ROUTES } from '../../constants';
import './experimental-dashboard.scss';

const ExperimentalDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ContentLayout
      defaultPadding
      header={
        <Header variant="h1" description="Experimental features and tools">
          Experimental Mode
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <Container>
          <div className="experimental-card">
            <div className="experimental-card__icon">🧩</div>
            <div className="experimental-card__content">
              <Box variant="h2">Skill Repository</Box>
              <Box variant="p" color="text-body-secondary">
                Create, manage, and version your skills and plugins. Upload skill packages,
                view file contents, and manage versions.
              </Box>
            </div>
            <div className="experimental-card__action">
              <Button variant="primary" onClick={() => navigate(ROUTES.SKILL_MANAGEMENT)}>
                View
              </Button>
            </div>
          </div>
        </Container>
      </SpaceBetween>
    </ContentLayout>
  );
};

export default ExperimentalDashboard;
